import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/gmizmnqa_peerwave%20logo.jpg";

export const Logo = ({ className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      aria-label="PeerWave — Find your voice, find your tribe"
      className={`inline-flex items-center group ${className}`}
    >
      <div className="relative overflow-hidden h-16 sm:h-20 w-40 sm:w-56">
        <img
          src={LOGO_URL}
          alt="PeerWave — Find your voice, find your tribe"
          loading="eager"
          className="absolute left-1/2 top-1/2 h-[240%] w-auto max-w-none -translate-x-1/2 -translate-y-[42%] object-contain transition-transform duration-500 group-hover:scale-[1.03]"
          style={{ mixBlendMode: "multiply" }}
        />
      </div>
    </Link>
  );
};

export default Logo;
